import { render, staticRenderFns } from "./PicaTable.vue?vue&type=template&id=99f9197a&scoped=true&"
import script from "./PicaTable.vue?vue&type=script&lang=js&"
export * from "./PicaTable.vue?vue&type=script&lang=js&"
import style0 from "./PicaTable.vue?vue&type=style&index=0&id=99f9197a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9197a",
  null
  
)

export default component.exports